import styled from 'styled-components';
import {
    BACKGROUND_DEEP,
    TERTIARY_BACKGROUND,
} from '@amzn/ring-common-style-library/lib/colors';

const Widget = styled.div`
    display: flex;
    flex-direction: column;

    height: 100%;
    width: 100%;
    overflow: hidden;

    background-color: ${BACKGROUND_DEEP};
    border-radius: 8px;
    border: 1px solid ${TERTIARY_BACKGROUND};
    box-shadow: 0px 8px 12px 0px var(--shadow-base, rgba(0, 0, 0, 0.15));
`;

export default {
    Widget,
};
